export const TITLE = 'This is an English title';
export const HEADER_TITLE = 'Header title';
export const CHANGE_LANGUAGE = 'Change Language to Spanish';

/* LANGUAGES */
export const EN = 'English (EN)';
export const ES = 'Español (ES)';

export const EN_ID = 'EN';
export const ES_ID = 'ES';

export const LANGUAGE = 'en';

export const NAME_APP = 'TEA Ayudo';

/* HEADER TEXTS */
export const HEADER_NAV_HOME = 'Home';
export const HEADER_NAV_USERS = 'Users';
export const HEADER_NAV_HOW_DOES_IT_WORKS = 'How does it works?';
export const HEADER_NAV_LOGIN = 'Sign Up or \n Sign In';

export const HEADER_LANGUAGE = '▾ English (EN)';

/* LOGIN TEXTX */
export const LOGIN_TITLE = 'Login';
export const LOGIN_SUBTITLE = 'Login with your email';
export const LOGIN_EMAIL = 'Email';
export const LOGIN_PASSWORD = 'Password';
export const LOGIN_FORGOT_PASSWORD = 'Forgot your password?';
export const LOGIN_REGISTER = "Don't have an account? ";
export const LOGIN_BUTTON = 'Sign in';
export const LOGIN_ERROR = 'Login failed';
export const LOGIN_SOCIAL = 'Or login with';
export const LOGIN_TERMS =
  'By signing up, you agree to our Terms of Service and Privacy Policy.';
export const LOGIN_TERMS_LINK = 'Terms of Service';
export const LOGIN_REGISTER_BUTTON = 'Sign up';

/* Loading */
export const LOADING_TITLE = 'Loading...';

/* Sign up TEXT */
export const SIGNUP_TITLE = 'Sign up';
export const SIGNUP_SUBTITLE = 'Sign up with your email';
export const SIGNUP_EMAIL = 'Email';
export const SIGNUP_PASSWORD = 'Password';
export const SIGNUP_CONFIRM_PASSWORD = 'Confirm password';
export const SIGNUP_BUTTON = 'Register';
export const SIGNUP_ERROR = 'Error registering';
export const SIGNUP_SOCIAL = 'Or register with';
export const SIGNUP_NAME = 'Name';
export const SIGNUP_SURNAME = 'Surname';
export const LOGIN_SINGUP = 'Already have an account?';
export const LOGIN_SINGUP_ACTION = 'Login';

/*Footer Text */
export const FOOTER_TITLE = 'Pictograms';
export const FOOTER_CONTACT = 'Contact';
export const FOOTER_TERMS = 'Terms of Service';
export const FOOTER_PRIVACY = 'Privacy Policy';
export const FOOTER_COPYRIGHT =
  'Copyright © 2022 Pictograms. All rights reserved. Design by';
export const FOOTER_MADE = 'Made with';
export const FOOTER_TEXT = [
  {
    title: 'TeAyuda',
    content: 'Teamwork is a way to grow',
    content2: 'About us and our services',
    content3: 'We support a community of people who want to help',
  },
  {
    title: 'About Us',
    content: 'We are a community of people who want to help others',
    content2: 'We can help anyone who wants to help',
    content3: 'We are a team of people who want to help',
  },
  {
    title: 'Contact Us',
    content: 'Madrid, ESP, Spain',
    content2: 'Calle Ventura Rodriguez, 28008 Madrid.',
    content3: 'Social Media Links (Facebook, Twitter, Instagram, Google)',
  },
];

/* HOME Hero */
export const HERO_TITLE =
  'Symbol set and resources for Augmentive and \nAlternative Communicación (AAC)';
export const HERO_SUBTITLE = 'Sign up or Sign in to use the app! ';
export const HERO_BUTTON = 'Sign up / Login';
export const HERO_NO_SIGNUP = 'Continue without an account';

/* HOME INFO */
export const TOP_PAGE = 'Scroll to the top ⬆';
export const HOW_WORKS_TITLE = 'How does it work?';
export const HOW_WORKS_INFO = [
  {
    title: 'Comunication',
    description:
      'Communication and language are essential for every human being to interact with other people. Today, thanks to these systems, they can’t be restrained by the difficulties with the oral language.',
  },
  {
    title: 'Favourites',
    description:
      'Sign up if you want to save your favourite words, routines, schedules...',
  },
  {
    title: 'Games and resources',
    description:
      'Education materials with symbols support improve cognitive accessibility and provide an additional visual stimulation and motivation to learn. ',
  },
  {
    title: 'AAC Users',
    description:
      'Symbols can help anyone who has difficulties with the language because of different reasons (autism, intellectual disability, lack of language, elderly people, etc.) or who simply don’t understand the language (foreign people, migrants...).',
  },
];
export const USERS_TITLE = 'Users';
export const USERS = [
  {
    title:
      'Children and adults with severe physical difficulties (cerebral palsy, head trauma, ictus...)',
    description:
      'In cases where motor abilities are affected and disallow the use of oral language, the use of symbols becomes an alternative communication system that allows people to connect with their world and communicate not only their needs, wants or desires, but also their ideas, emotions and opinions.',
  },
  {
    title:
      'Children with special needs (autism, intellectual disability, Down syndrome, hearing impairment...)',
    description:
      'For most of the children with some of these difficulties, language development is a challenge that is eased with visual supports. In most of these cases, the communication with symbols becomes augmentative because these aids are a way to develop the oral and written language to a certain degree. On the other hand, visual supports are a way to make their environment more predictable and understandable, facilitating the learning and the development of life skills.',
  },
  {
    title: 'Elderly people',
    description:
      'In some cases, elderly people suffer a cognitive impairment due to afasia, Alzheimer, dementia or other psychiatric diseases that make necessary the use of an augmentative or alternative communication system with symbols that allow them to communicate. These visual supports can be a temporary or permanent aid.',
  },
  {
    title: 'People in an emergency or sanitary situation',
    description:
      'If someone is intubated in the ICU of a hospital, has had an accident or is in shock after having an attack and is unable to speak, symbols can be used as a communication system that allow the user to express to the professional how they feel and what happened in order to get information about the patient. In other cases, communication through symbols allows doctors to explain medical procedures when patients dont speak the local language and to obtain their informed consent.',
  },
  {
    title: 'Tourists and visitors to foreign countries',
    description:
      'In places where they receive many tourists or foreigners live for a limited period of time, symbols are used to facilitate cognitive accessibility to culture (museums, monuments, attractions...), to facilitate shopping (communication boards adapted to different types of stores) and being able to eat in a restaurant (adapted menus) and even to make access to administrative procedures easier when the person temporarily residing in a place needs it',
  },
  {
    title: 'Children beginning to read or with reading difficulties',
    description:
      'Symbols can help children to understand written text when they are beginning to read or when they have difficulties, decoding the meaning of the written word. In other cases like dislexia, it can help to improve reading decoding and to avoid letter confusions. In general, it contributes to learning words through global reading. This is why we always recommend that symbols are accompanied by text under or above them',
  },
  {
    title: 'For everyone',
    description:
      'For anyone who moves to an unknown place inside or outside their country, the use of visual aids will allow them to access and orient themselves more easily in their environment and communicate with other people. We live in an eminently visual world and therefore, symbols that are part of the visual language that surrounds us, are familiar and easy to understand.',
  },
];

/* DASHBOARD */
export const DASHBOARD = 'Dashboard';
export const DASHBOARD_PICTOGRAMS = 'Pictograms';
export const DASHBOARD_SEARCH = 'Enter seach text';
export const DASHBOARD_ALL_CATEGORIES = 'All categories';

/* Aside */
export const ASIDE_HOME = 'Home';
export const ASIDE_FAVO = 'Favorites';
export const ASIDE_EASY = 'Easy to use';
export const ASIDE_SETTINGS = 'Settings';
export const ASIDE_HELP = 'Help';
export const ASIDE_LOGOUT = 'Logout';
export const ASIDE_FEEDBACK = 'Feedback';

// categories
export const DASHBOARD_CATEGORIES = [
  { id: 'Food', endpoint: '/search/food' },
  { id: 'Place', endpoint: '/search/place' },
  { id: 'education', endpoint: '/search/education' },
  { id: 'Time', endpoint: '/search/time' },
  { id: 'Comunication', endpoint: '/search/comunication' },
  { id: 'Feeling', endpoint: '/search/feeling' },
  { id: 'Animals', endpoint: '/search/animals' },
  { id: 'People', endpoint: '/search/people' },
  { id: 'Plants', endpoint: '/search/plants' },
  { id: 'Colours', endpoint: '/search/colours' },
  { id: 'Numbers', endpoint: '/search/numbers' },
];

export const DASHBOARD_CATEGORIES_ALL = 'All categories';

/* Favorites */
export const FAVO_TITLE = 'Favorites';

// Error messages
export const ERROR_TITLE = 'An Error Has Occurred';
export const ERROR_BUTTON_TEXT = 'Retry';
export const ERROR_LOGIN =
  'This functionality is not implemented in this version of the app.';

// Boton mostrar mas fav ori t assembled os
export const SHOW_MORE_FAVORITES = 'Show  more favorites';
export const SHOW_LESS_FAVORITES = 'Show less favorites';
